export enum AuthRedirectReason {
    TokenRefreshFailed = 'token_refresh_failed',
    AuthRefreshError = 'auth_refresh_error',
    AuthGuardUnauthenticated = 'auth_guard_unauthenticated',
    Http401AfterRetry = 'http_401_after_retry',
    IdleTimeout = 'idle_timeout',
    ManualLogout = 'manual_logout',
    LogoutComponent = 'logout_component',
    SsoLogout = 'sso_logout',
}

export const AUTH_REDIRECT_STATE_KEY = 'authRedirectReason';
